import { UserGroup, userGroupPermissionRank } from '@/modules/Permissions/Permissions.constants';
import { routes, userGroupIndexMap } from '@/modules/Router/Router.constants';

import { Route } from './types';

export const getIndexRoute = (userGroups: UserGroup[] | undefined): string => {
  if (!userGroups) {
    return routes.login;
  }
  const highestUserRole = userGroupPermissionRank.find((role) => userGroups.includes(role));
  return highestUserRole ? userGroupIndexMap[highestUserRole] : routes.farms;
};

export const setRouteParam = (route: Route, param: string, value: string) => {
  const params = new URLSearchParams();
  params.set(param, value);
  return `${route}?${params.toString()}`;
};

export const makeRoute = (
  route: Route,
  params: Record<string, string | number | undefined>,
  fallback = window.location.pathname
): string => {
  const segments = route.split('/').map((segment) => {
    if (segment.startsWith(':')) {
      const key = segment.substring(1);
      return key in params ? String(params[key]) : undefined;
    }
    return segment;
  });

  if (segments.some((segment) => segment === undefined)) {
    return fallback;
  }
  return segments.join('/');
};
